import { render, staticRenderFns } from "./UpdateRecordList.vue?vue&type=template&id=41946275&scoped=true&"
import script from "./UpdateRecordList.vue?vue&type=script&lang=js&"
export * from "./UpdateRecordList.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRecordList.vue?vue&type=style&index=0&id=41946275&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41946275",
  null
  
)

export default component.exports